import Dropdown from "components/dropdown/Dropdown";
import { ExternalUser, SalesPerson } from "models/customers/customers";
import { Subscriber } from "models/dashboard/dashboard";

type RecipientItem = {
  isFixed?: boolean;
  label: string;
  value: string;
};

type Props = {
  selectedRecipients: (SalesPerson | ExternalUser | Subscriber)[];
  availableRecipients: (SalesPerson | ExternalUser)[];
  onChange: (recipient: (SalesPerson | ExternalUser)[]) => void;
};

export default function RecipientsSelectorWithAbsenceMessage({
  selectedRecipients,
  availableRecipients,
  onChange
}: Props) {
  const handleSelectedChange = (users: RecipientItem[]) => {
    const toUsers = users.map((user) => {
      // First, try to find the user in availableRecipients
      const availableUser = availableRecipients.find(
        (availableRecipient) => availableRecipient.id === user.value
      );

      if (availableUser) {
        return { ...availableUser, isFixedRecipient: user.isFixed };
      }

      // If not found in availableRecipients, check if it's an existing selected recipient
      // (e.g., thread creator or existing participants)
      const existingRecipient = selectedRecipients.find(
        (recipient) => recipient.id === user.value
      );

      if (existingRecipient) {
        return { ...existingRecipient, isFixedRecipient: user.isFixed } as SalesPerson | ExternalUser;
      }

      // If still not found, throw an error
      throw new Error("Could not match user");
    });

    onChange(toUsers as (SalesPerson | ExternalUser)[]);
  };

  const availableRecipientsOptions = availableRecipients.map((recipient) => ({
    value: recipient.id,
    label: `${recipient.givenName} ${recipient.surName}`,
    isFixed: recipient.isFixedRecipient
  }));

  const selectedRecipientsOptions = selectedRecipients.map((recipient) => ({
    value: recipient.id,
    label: `${recipient.givenName} ${recipient.surName}`,
    isFixed: recipient.isFixedRecipient
  }));

  const absentRecipients = selectedRecipients.filter(
    (recipient) => recipient.outOfOfficeMessage
  );

  return (
    <>
      <Dropdown
        options={availableRecipientsOptions}
        values={selectedRecipientsOptions}
        isMulti={true}
        isSearchable={true}
        isClearable={false}
        placeholder="Lägg till mottagare"
        onChange={(selected) => {
          if (selected) {
            const value = selected as RecipientItem[];
            handleSelectedChange(value);
          }
        }}
      />

      {absentRecipients.length > 0 && (
        <div className="mt-4">
          <label className="mb-3">Frånvaromeddelanden</label>

          {absentRecipients.map((recipient) => {
            return (
              <div className="mt-0 out-of-office-wrapper" key={recipient.id}>
                <b>
                  {recipient.givenName} {recipient.surName}
                </b>
                <div className="marginTop out-of-office-message">
                  {recipient.outOfOfficeMessage &&
                    recipient.outOfOfficeMessage
                      .split("\n")
                      .map((item, key) => {
                        return (
                          <span key={key}>
                            {item}
                            <br />
                          </span>
                        );
                      })}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
